import axios from "axios";

// Public axios instance for the external giftor portal. No auth interceptor
// and no login-redirect — giftors are not app users; they authenticate with
// an email OTP and hold a short-lived giftor token in memory only.
export const giftorPublic = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

export const giftorDeclarationUrl = (token) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/giftor/declaration.pdf?token=${encodeURIComponent(token)}`;
